var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#001246",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M834.134 466.32L833.04 476h-7.663l-1.095-9.68h9.852zm-1.21 1.076h-7.432l.875 7.528h5.68l.877-7.528zm-4.81 1.613c.268 0 .492.19.538.441l.009.097v3.226c0 .297-.245.538-.547.538-.27 0-.493-.19-.539-.44l-.009-.098v-3.226c0-.297.245-.538.548-.538zm2.189 0c.269 0 .492.19.538.441l.01.097v3.226c0 .297-.246.538-.548.538-.269 0-.492-.19-.539-.44l-.008-.098v-3.226c0-.297.245-.538.547-.538zm.812-5.151l.018.124 3.272-.281c.301-.026.567.193.593.488.023.263-.15.499-.4.566l-.098.017-10.905.937c-.301.026-.567-.193-.593-.488-.023-.263.15-.499.4-.566l.098-.017 3.271-.281c-.052-.592.393-1.114.995-1.165l2.181-.188c.56-.048 1.057.326 1.168.854z",
    transform: "translate(-823 -463)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteShape);
export default __webpack_public_path__ + "static/media/delete-shape.9e333af58591a0926e3ef775d7c85d7a.svg";
export { ForwardRef as ReactComponent };